<div
  class="general-info"
  [class.selected]="isSelected">
  @if (warning) {
    <div>
      <mat-icon
        matTooltip="{{ warning }}"
        class="warning-icon">
        warning
      </mat-icon>
    </div>
  }

  @if (orgBoxActions?.length > 0) {
    <button
      class="no-style menu-button"
      [matMenuTriggerFor]="orgBoxMenu"
      [attr.aria-label]="'org-management.toggle-org-box-menu' | translate"
      (click)="$event.stopPropagation()">
      <mat-icon>more_vert</mat-icon>
    </button>
    <mat-menu #orgBoxMenu="matMenu">
      @for (menuItem of orgBoxActions; track menuItem) {
        <button
          matTooltip="{{
            menuItem.disabled(organisation) && menuItem.disabledTooltip ? (menuItem.disabledTooltip | translate) : null
          }}"
          mat-menu-item
          class="text"
          matTooltipPosition="right"
          [disabled]="menuItem.disabled(organisation)"
          (click)="menuItem.action(organisation)">
          {{ menuItem.title | translate }}
        </button>
      }
    </mat-menu>
  }

  <button
    class="no-style org-button"
    [disabled]="!selectable"
    [attr.aria-label]="'org-management.open-organisation-details' | translate"
    [matTooltip]="$safeNavigationMigration(organisation?.tag?.text) | translate"
    [matTooltipDisabled]="!hasTag"
    [matTooltipPosition]="'above'"
    [matTooltipClass]="'org-deviation-tooltip'"
    (click)="select()">
    <div class="top-info">
      <div
        class="spacer"
        [class.more-space]="warning"></div>
      <div class="name">
        <p
          coinEllipsisTooltip
          matTooltip>
          {{ organisation?.orgCode }}
        </p>
        <p
          coinEllipsisTooltip
          matTooltip
          class="bold">
          {{ organisation?.name }}
        </p>
      </div>
      <div
        class="spacer"
        [class.more-space]="orgBoxActions?.length > 0"></div>
    </div>

    @if (hasTag) {
      <div class="tag">
        <mat-icon>{{ organisation?.tag?.icon }}</mat-icon>
        <p>{{ $safeNavigationMigration(organisation?.tag?.title) | translate }}</p>
      </div>
    }

    <div class="middle-info">
      <div class="incumbent">
        @if (!organisation?.heads?.length || organisation.heads.length === 1) {
          <coin-siemens-energy-employee-preview
            showPreferredName="ifAvailable"
            [placeholderText]="'org-management.info.no-employee-assigned' | translate"
            [employee]="organisation?.heads?.length ? organisation?.heads[0].employee : undefined"
            [showFlag]="false"
            [boldName]="false"
            [showOrgCode]="false"
            [tiny]="true"
            [namePrefix]="
              organisation?.heads?.length && organisation.heads[0].isActing ? 'act.' : ''
            "></coin-siemens-energy-employee-preview>
        } @else {
          @if (organisation?.heads?.length > 1) {
            <p
              coinEllipsisTooltip
              matTooltip>
              {{ headsDisplayString }}
            </p>
          }
        }
      </div>
      @if (showDirectsCount) {
        <p
          matTooltip="{{ 'org-management.direct-reports' | translate }}"
          class="direct-reports">
          <mat-icon svgIcon="bee"></mat-icon>
          {{ organisation?.spanOfControl ?? 0 | number }}
        </p>
      }
    </div>
  </button>

  <div class="bottom-info">
    <button
      class="left no-style"
      [attr.aria-label]="'org-management.toggle-employee-list' | translate"
      (click)="togglePositionList()">
      <div class="content-wrapper">
        <mat-icon matTooltip="{{ 'org-management.persons-info-text' | translate }}">people_alt</mat-icon>
        <p>
          {{ $safeNavigationMigration(organisation?.numberOfEmployees) | number }}
          {{ organisation?.totalNumberOfEmployees ? '(' + (organisation.totalNumberOfEmployees | number) + ')' : '' }}
        </p>
      </div>
      <mat-icon
        class="arrow-icon"
        [class.open]="isPositionsListVisible">
        keyboard_arrow_down
      </mat-icon>
    </button>
    @if (organisation?.numberOfOpenJobs > 0) {
      <div class="separator"></div>
    }
    @if (organisation?.numberOfOpenJobs > 0) {
      <button
        matTooltip="{{ 'org-management.open-jobs-info-text' | translate }}"
        class="right no-style"
        [attr.aria-label]="'org-management.open-jobs-info-text' | translate"
        (click)="openJobsClicked.emit(organisation)">
        <mat-icon>work</mat-icon>
        <p>{{ organisation?.numberOfOpenJobs }}</p>
      </button>
    }
  </div>
</div>

@if (isPositionsListVisible) {
  <ul class="position-list">
    @if (positionsLoading$ | async) {
      <div class="loading">
        <app-loading-screen
          [local]="true"
          [contrast]="true"></app-loading-screen>
      </div>
    } @else {
      @for (position of positions$ | async; track position) {
        <li
          class="position"
          [class.head]="position?.isHead"
          [class.selected]="position?.employee?.id === selectedEmployeeId">
          <button
            class="no-style"
            [disabled]="!position?.employee"
            [attr.aria-label]="'org-management.show-employee-info' | translate"
            (click)="positionSelected.emit(position)">
            <coin-siemens-energy-employee-preview
              showPreferredName="ifAvailable"
              [placeholderText]="'org-management.info.no-employee-assigned' | translate"
              [employee]="$safeNavigationMigration(position?.employee)"
              [boldName]="false"
              [showOrgCode]="false"
              [tiny]="true"
              [customTopInfo]="
                position?.isHead ? [position.shortTitle ? position.shortTitle : position.title] : []
              "></coin-siemens-energy-employee-preview>
          </button>
        </li>
      }
    }
  </ul>
}
